class CollectionCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slides.length < 2) return

    this.initialise()
    this.setupListeners()
    this.updateArrowVisibility()
  }

  setupListeners () {
    this.els.prev.element.addEventListener('click', () => this.carouselInstance.prev())
    this.els.next.element.addEventListener('click', () => this.carouselInstance.next())
  }

  initialise() {
    this.carouselInstance = new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        slides: {
          perView: '1.3',
          spacing: 5,
        },
        breakpoints: {
          '(min-width: 990px)': {
            slides: {
              perView: '2',
              spacing: 5,
            },
          },
          '(min-width: 1200px)': {
            slides: {
              perView: '4',
              spacing: 5,
            },
          },
        },
      },
    )

    this.carouselInstance.on('slideChanged', () => this.updateArrowVisibility())
  }

  updateArrowVisibility () {
    if (!this.carouselInstance) return

    const details = this.carouselInstance.track.details
    const current = details.rel
    const last = details.maxIdx

    this.els.prev.element.setAttribute('aria-disabled', current === 0 ? 'true' : 'false')
    this.els.next.element.setAttribute('aria-disabled', current >= last ? 'true' : 'false')
  }
}

if (!customElements.get('collection-carousel')) {
  customElements.define('collection-carousel', CollectionCarousel)
}
